import { Composition } from "remotion";
import { surveyVideoSchema } from "./lib/schema";
import SurveyVideo from "./Video/SurveyVideo";

export const RemotionRoot: React.FC = () => {
  return (
    <Composition
      id="SurveyVideo"
      component={SurveyVideo}
      schema={surveyVideoSchema}
      defaultProps={{
        itemX: "コーヒー",
        itemY: "緑茶",
        cities: [],
        outlierSigma: 3,
      }}
      durationInFrames={1020}
      fps={30}
      width={1920}
      height={1080}
    />
  );
};
